<template>
  <b-card
    :title="$t('Settings')"
  >

    <form-settings
      :key="'settingsform'"
      ref="settings_form"
    />

  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import FormSettings from '@/layouts/components/forms/FormSettings.vue'

export default {
  components: {
    BCard,
    FormSettings,
  },
}
</script>
